module.exports = __webpack_public_path__ + "img/18-HEZ.36e87ed.png";